import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
    background: '#F0F0F0',
    overflow: 'hidden',
  },
  header: {
    boxSizing: 'border-box',
    background: theme?.palette?.header?.main,
    height: '46px',
    width: '100%',
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '16px',
  },
  body: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    padding: '24px',
    boxSizing: 'border-box',
  },
  card: {
    background: 'white',
    borderRadius: '12px',
    padding: '40px 48px',
    width: '100%',
    maxWidth: '480px',
    boxSizing: 'border-box',
    border: `solid 1px ${theme?.palette?.borders?.main || '#e0e0e0'}`,
    boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  iconCircle: {
    width: '68px',
    height: '68px',
    borderRadius: '50%',
    background: `${theme?.palette?.primarySelection?.main}1a` || '#e6faf6',
    border:
      `2px solid ${theme?.palette?.primarySelection?.main}40` ||
      '2px solid #1a9c7c40',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '24px',
  },
  icon: {
    fontSize: '34px',
    color: theme?.palette?.primarySelection?.main || '#1a9c7c',
  },
  title: {
    fontSize: '22px',
    fontWeight: 700,
    color: '#202020',
    marginBottom: '10px',
    textAlign: 'center',
  },
  subtitle: {
    fontSize: '14px',
    color: '#666666',
    marginBottom: '28px',
    lineHeight: 1.7,
    textAlign: 'center',
    maxWidth: '340px',
  },
  divider: {
    width: '100%',
    height: '1px',
    background: theme?.palette?.borders?.main || '#e0e0e0',
    marginBottom: '28px',
  },
  button: {
    background: theme?.palette?.secondaryButton?.main,
    color: theme?.palette?.secondaryButton?.contrastText,
    fontWeight: theme?.palette?.secondaryButton?.fontWeight,
    border: `solid 1px ${theme?.palette?.primarySelection?.main}`,
    padding: '10px 36px',
    fontSize: '15px',
    marginBottom: '20px',
    '&:hover': {
      background: theme?.palette?.secondaryButton?.hover,
    },
  },
  hint: {
    fontSize: '12px',
    color: '#999999',
    textAlign: 'center',
  },
  key: {
    display: 'inline-block',
    background: '#f5f5f5',
    border: '1px solid #d0d0d0',
    borderBottom: '2px solid #b0b0b0',
    borderRadius: '4px',
    padding: '1px 7px',
    fontFamily: 'monospace',
    fontSize: '11px',
    color: '#444',
    lineHeight: 1.6,
  },
}))

export { useStyles }
